import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';

import {Box, Container, Stack, Typography} from 'views/components';
import {translate} from 'views/module';

import EventTile from './tiles/EventTile';
import EventTileSkeletons from './skeleton_loaders/EventTileSkeletons';

const EventList = (props) => {
  const {
    weekDays,
    loading,
    selectedEvent,
    handleEventClick,
  } = props;

  return (
    <Container
      sx={{
        py: 3,
        height: '80vh',
        overflowY: 'auto',
        boxSizing: 'border-box',
      }}
    >
      <Box sx={{position: 'relative'}} data-container="schedule">
        <Box>
          <Stack spacing={3}>
            {
              loading &&
              <EventTileSkeletons daysCount={5} eventsPerDay={3} />
            }
            {
              !loading &&
              weekDays.map(({dayKey, events, date}) => {
                const userTimezone = moment.tz.guess();
                const isToday = moment.tz(date, userTimezone).isSame(moment.tz(userTimezone), 'day');
                const displayDay = isToday ? translate('eventList.Today') : dayKey;

                return (
                  <Box key={dayKey}>
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 600,
                        mb: 2,
                        color: isToday ? 'primary.main' : 'text.primary',
                        padding: isToday ? '8px 12px' : '0',
                        borderRadius: isToday ? '8px' : '0',
                        display: 'inline-block',
                      }}
                    >
                      {displayDay}
                    </Typography>
                    <Stack spacing={2}>
                      {
                        events.length > 0 && events.map((event) => (
                          <Box
                            key={event.eventRn}
                            onClick={(e) => handleEventClick(event, e)}
                            sx={{
                              '&, & *': {cursor: 'pointer !important'},
                              'borderRadius': 2,
                            }}
                          >
                            <EventTile
                              event={event}
                              selected={selectedEvent && selectedEvent.eventRn === event.eventRn}
                            />
                          </Box>
                        ))
                      }
                      {
                        events.length === 0 && (
                          <Box
                            sx={{
                              p: 2,
                              textAlign: 'center',
                              color: 'text.secondary',
                              fontStyle: 'italic',
                            }}
                          >
                            <Typography variant="body2">
                              {translate('eventList.noEvents')}
                            </Typography>
                          </Box>
                        )
                      }
                    </Stack>
                  </Box>
                );
              })
            }
          </Stack>
        </Box>
      </Box>
    </Container>
  );
};

EventList.propTypes = {
  weekDays: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  selectedEvent: PropTypes.object,
  handleEventClick: PropTypes.func.isRequired,
};

export default React.memo(EventList);
